import {
  EnablePermanentJobM2M,
  EnforcePermanentJobV2,
  ReadOfficeDetailFromOrgService,
} from '~/constants/ff.posthog';
import PosthogService from './PosthogService';

export const FeatureFlagUtils = {
  isEnablePermanentJobM2M: () =>
    PosthogService.getInstance().isFeatureEnabled(EnablePermanentJobM2M),
};

export const getShouldEnforcePermanentJobV2 = (): boolean =>
  PosthogService.getInstance().isFeatureEnabled(EnforcePermanentJobV2);

export const getShouldReadOfficeDetailFromOrgService = (): boolean =>
  PosthogService.getInstance().isFeatureEnabled(ReadOfficeDetailFromOrgService);
